import {
  useMutation,
  type MutationState,
} from 'src/core/api/hooks/useMutation';

type Payload = {
  vendorId: string;
  supplierId: string;
};

export const vendorSupplierMapQueriesToInvalidate = [
  'useGetVendorsQuery',
  ['suppliers', 'vendors', 'useSuppliersSyncStatus'],
  ['suppliers', 'suppliersDetails'],
];

export const useAssignVendorToSupplierMutation = (): MutationState<Payload> => {
  return useMutation<Payload>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      method: 'put',
      endpoint: '/accounting-integration/supplier-sync/vendor-supplier-map',
    },
    options: {
      onSuccess({ client }): void {
        vendorSupplierMapQueriesToInvalidate.forEach((q) =>
          client.invalidateQueries(q),
        );
      },
    },
  });
};
